import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=1db7038c&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=1db7038c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7038c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db7038c')) {
      api.createRecord('1db7038c', component.options)
    } else {
      api.reload('1db7038c', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=1db7038c&scoped=true", function () {
      api.rerender('1db7038c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/integralManage/record/dialogs/Detail.vue"
export default component.exports